import { createSelector } from 'reselect';
import { getCollectionsNew } from '../collections';
import { IStoreState } from '../../types';

export const getCollectionDesign = createSelector([getCollectionsNew], (collection) => ({
  design: collection.design,
  font: collection.font,
  buttonStyle: collection.buttonStyle,
  styles: collection.styles,
  galleryStyle: collection.galleryStyle,
  templateName: collection.templateName,
  type: collection.type
}));

/** Whether a collection change is still on its way to the API. */
export const getIsCollectionSaving = (state: IStoreState) => state.collectionSaving.pending > 0;
